import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
import Block from "cms/components/shared/Block";
import wrappable from "cms/utils/wrappable";
var GlossaryItem = wrappable(function (props) {
    var word = props.word, description = props.description;
    return (_jsxs(Block, { children: [_jsx(Typography, { variant: "h3", sx: { m: 0 }, children: word }), _jsx("div", { style: { marginTop: 0.5 }, children: description })] }));
});
export default GlossaryItem;
